<rt-placeholder-category-select-dropdown
  [header]="'app.wyswig.placeholders.replace_with' | translate"
  [placeholders]="filteredPlaceholders"
  [selectFooterTemplate]="footerTemplate"
  [active]="active"
  (select)="emitPlaceholderChange($event)"
/>

<ng-template #footerTemplate>
  <rt-dropdown-item (mousedown)="deletePlaceholder($event, active)" class="clickable">
    <rt-icon prefix name="remove-circle" size="small-x" />
    {{ 'app.wyswig.placeholders.remove' | translate }}
  </rt-dropdown-item>
</ng-template>
